import { FC } from 'react'
import {
    Outlet
} from "react-router-dom";


const Agent: FC = () => {  
    return (
        <Outlet />
    );
}

export default Agent